import { render, staticRenderFns } from "./vr.vue?vue&type=template&id=2b76e4ea&scoped=true&"
import script from "./vr.vue?vue&type=script&lang=js&"
export * from "./vr.vue?vue&type=script&lang=js&"
import style0 from "./vr.vue?vue&type=style&index=0&id=2b76e4ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b76e4ea",
  null
  
)

export default component.exports